<template>
  <div class="p-8 bg-neutral-300">
    <Lynx-Title text="Acessos do cliente" />
    <div class="grid grid-cols-3 gap-8">
      <AcessoItem
        v-for="item in acessoItems"
        :key="item.id"
        :acesso-item="item"
        @update-acesso="onUpdateAcesso"
      />
    </div>
  </div>
</template>

<script>
import AcessoItem from "@/views/clientes/show/AcessoItem";

export default {
  name: "AcessoDetail",
  components: { AcessoItem },
  props: {
    acesso: {
      required: true,
      type: Array,
    },
  },
  computed: {
    acessoItems() {
      // Defina uma lista dos itens desejados
      const tipos = [
        { label: "Meu Inss", tipo: "meu_inss" },
        { label: "Meu Gov", tipo: "meu_gov" },
        // Adicione mais itens aqui conforme necessário
      ];

      // Mapeie essa lista para construir o array final
      const resultado = tipos.map((item) => ({
        label: item.label,
        tipo: item.tipo,
        acesso: this.acesso.find((acessoItem) => acessoItem.type === item.tipo),
      }));

      return resultado;
    },
  },
  methods: {
    onUpdateAcesso() {
      this.$emit("update-acesso");
    },
  },
};
</script>
